import { useCallback, useState } from 'react'
import { ConfirmDeleteModal } from '../components/ConfirmDeleteModal'

interface PendingDelete {
  message: string
  action: () => void
}

export function useConfirmDelete() {
  const [pending, setPending] = useState<PendingDelete | null>(null)

  const confirmDelete = useCallback((message: string, action: () => void) => {
    setPending({ message, action })
  }, [])

  const handleConfirm = () => {
    pending?.action()
    setPending(null)
  }

  const ConfirmModal = (
    <ConfirmDeleteModal
      isOpen={pending !== null}
      message={pending?.message ?? ''}
      onConfirm={handleConfirm}
      onCancel={() => setPending(null)}
    />
  )

  return { confirmDelete, ConfirmModal }
}
